import { camelCase, isNil } from "lodash";

export const enumTranslationFormatter = (valueEnum: any, translationPrefix = 'common') => params => {
  const status = !isNil(params.value) && valueEnum[params.value] ? camelCase(valueEnum[params.value]) : 'noStatus';
  return `${translationPrefix}.${status}`;
};
